module.exports = __webpack_public_path__ + "static/img/2.3ea9768.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productCenter/2.png
// module id = MZF6
// module chunks = 0